import CyberLegends from './CyberLegends';

export default CyberLegends;
